var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF0000;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.17,23.16h9.21c1.39,0,1.68-0.87,1.28-1.64l-9.07-15.3c-0.39-0.66-0.9-1.01-1.42-1.02v3.4 c0.83-0.01,1.67,0.33,1.58,1.13l-0.95,8.65h-0.62h-0.01v1.01h0.01c0.75,0,1.36,0.59,1.36,1.32s-0.61,1.32-1.36,1.32h-0.01V23.16z  M12.79,6.16l-9.1,15.35c-0.4,0.77-0.11,1.64,1.28,1.64h9.21v-1.14c-0.75,0-1.35-0.59-1.35-1.32s0.6-1.32,1.35-1.32v-1.01h-0.61 l-0.97-8.8c-0.07-0.6,0.76-0.96,1.58-0.97v-3.4C13.68,5.18,13.18,5.5,12.79,6.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/WarningRed.e64570aa02b1f1822f60dff6ae85ca39.svg";
export { ForwardRef as ReactComponent };